import { render, staticRenderFns } from "./OtherResources.vue?vue&type=template&id=f2710b86&scoped=true&"
import script from "./OtherResources.vue?vue&type=script&lang=js&"
export * from "./OtherResources.vue?vue&type=script&lang=js&"
import style0 from "./OtherResources.vue?vue&type=style&index=0&id=f2710b86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2710b86",
  null
  
)

export default component.exports